import Phone from './phone-view';

export default Phone;
